//export const DOMAIN= "http://localhost:5001";
//xport const DOMAINCLIENT = "http://localhost:6075/";
//export const TAGGINGSERVERPATH = ""
//export const DOMAIN= "http://44.207.171.24:5001"
const isLocalhost = window.location.hostname === 'localhost';
const isUAT = window.location.hostname === 'uat-accelerator.enfusesolutions.com';

export const DOMAIN = process.env.REACT_APP_DOMAIN || (isLocalhost ? "http://localhost:3030" : isUAT ? "https://uat-accelerator.enfusesolutions.com" : "https://accelerator.tagi5.ai");
export const DOMAINCLIENT = process.env.REACT_APP_DOMAINCLIENT || (isLocalhost ? "http://localhost:3001" : isUAT ? "https://uat-tagging.enfusesolutions.com" : "https://annotation.tagi5.ai");